import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Server, Activity, Power, RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Providers() {
  const [items, setItems] = useState([]);
  const [health, setHealth] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const [a, b] = await Promise.all([api.get("/api/admin/providers"), api.get("/api/admin/providers/health")]);
    setItems(a.data); setHealth(b.data); setBusy(false);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (p) => {
    const action = p.status === "active" ? "disable" : "enable";
    await api.post(`/api/admin/providers/${p.provider_id}/${action}`);
    toast.success(`Provider ${action}d`);
    load();
  };

  const sync = async (p) => {
    const { data } = await api.post(`/api/admin/providers/${p.provider_id}/sync-games`);
    toast.success(`Synced ${data.synced} games from ${p.provider_name}`);
  };

  const healthFor = (code) => health.find(h => h.provider_code === code);

  return (
    <div className="space-y-6" data-testid="providers-page">
      <div className="text-[var(--text-2)] text-sm">Game providers connected to the aggregator. Live health from mock adapters.</div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {busy && <div className="text-[var(--text-2)] col-span-3 flex items-center gap-2"><Loader2 className="animate-spin" size={14}/> Loading…</div>}
        {!busy && items.map(p => {
          const h = healthFor(p.provider_code);
          return (
            <div key={p.provider_id} className="card-surface p-5 fade-up" data-testid={`provider-card-${p.provider_code}`}>
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded bg-[var(--surface-3)] border border-[var(--border)] flex items-center justify-center">
                    <Server size={18} className="text-[var(--gold)]"/>
                  </div>
                  <div>
                    <div className="font-semibold">{p.provider_name}</div>
                    <div className="text-xs text-[var(--text-3)] font-mono">{p.provider_code}</div>
                  </div>
                </div>
                <StatusBadge status={p.status}/>
              </div>
              <div className="grid grid-cols-3 gap-2 text-center mt-4 mb-4">
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)]">Health</div>
                  <div className="mt-1"><StatusBadge status={h?.status || "healthy"}/></div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)]">Uptime</div>
                  <div className="font-mono text-sm text-[var(--gold)] mt-1">{h?.uptime_pct || p.uptime_pct}%</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)]">Latency</div>
                  <div className="font-mono text-sm mt-1">{h?.latency_ms || p.avg_latency_ms}ms</div>
                </div>
              </div>
              <div className="text-xs text-[var(--text-2)] mb-3 font-mono break-all">{p.api_endpoint}</div>
              <div className="flex gap-2">
                <button onClick={() => sync(p)} className="btn-ghost px-3 py-1.5 rounded text-xs flex items-center gap-1.5" data-testid={`sync-${p.provider_code}`}>
                  <RefreshCw size={11}/> Sync games
                </button>
                <button onClick={() => toggle(p)} className="btn-ghost px-3 py-1.5 rounded text-xs flex items-center gap-1.5" data-testid={`toggle-${p.provider_code}`}>
                  <Power size={11}/> {p.status === "active" ? "Disable" : "Enable"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
